import { globalEventBus } from '@fiverr-private/futile';
import { STATS } from '../../helpers/eventName';
import { TYPES } from '../../helpers/types';
import logger from '../../../logger/emitter';

/**
 * Register an action to global eventbus
 * @param  {Function} options.action
 * @return {undefined}
 */
export default function statsListener({ action }) {
    if (globalEventBus.has(STATS)) {
        logger.warn(new Error(`OBS Duplicate registering attempted to ${STATS} bus`));
        return;
    }

    globalEventBus.on(STATS, ({ type, ...rest }) => {
        if (!TYPES.includes(type)) {
            throw new TypeError(`type must be one of: ${JSON.stringify(TYPES)}. Instead got "${type}"`);
        }

        action({ type, ...rest });
    });
}
